import type { AnimationParticlesProps } from './interfaces'

export const ANIMATION_PARTICLES_DEFAULTS: Required<AnimationParticlesProps> = {
  count: 16,
  tabletCount: 24,
  desktopCount: 32,
  cleanupGap: 200,
  minSize: 12,
  maxSize: 24,
}
